<template>
  <div v-loading.fullscreen.lock="loading">
    <h1 class="page-title">Customer details</h1>

    <div class="row">
      <div class="col-md-12">
        <div class="portlet light portlet-fit bordered">
          <div class="portlet-title">
            <div class="caption">
              <i class="fa fa-user font-green-haze"></i>
              <span class="caption-subject font-green-haze bold uppercase">Search customer</span>
            </div>
          </div>
          <div class="portlet-body">
            <tuango-user-search @onCustomerFound="onCustomer"></tuango-user-search>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12" v-for="customer in customers">
        <tuango-user-profile :key="customer.id"
                             :uid="customer.id"
                             :name="`${customer.firstName} ${customer.lastName}`"
                             :email="customer.email"
                             :source="customer.source"
                             :avatar="customer.avatar"
                             @onSectionSelected="showSection($event, customer)"
        />
      </div>
    </div>

    <div class="row" id="userdata">
      <div class="col-sm-12">
        <tuango-transactions :customerId="selectedCustomer['cust_uid']" v-if="currentView === 'transactions'">
          Transactions {{ selectedCustomer.firstName }} {{ selectedCustomer.lastName }} {{ selectedCustomer.id }}
        </tuango-transactions>
        <tuango-cards :cards="selectedCustomer['cards']" v-if="currentView === 'cards'">
          Cards {{ selectedCustomer.firstName }} {{ selectedCustomer.lastName }} {{ selectedCustomer.id }}
        </tuango-cards>
        <tuango-claims :cards="selectedCustomer['cards']" :claims="selectedCustomer['claims']"
                       v-if="currentView === 'claims'">
          Claims {{ selectedCustomer.firstName }} {{ selectedCustomer.lastName }} {{ selectedCustomer.id }}
        </tuango-claims>
      </div>
    </div>
  </div>
</template>

<script>
  /* ============
   * User Profile Page
   * ============
   *
   * User Profile page.
   */
  import to from 'await-to-js'

  // Transformers
  import CardTransformer from '@/app/transformers/CardTransformer'
  import ClaimTransformer from '@/app/transformers/ClaimTransformer'
  // Components
  import TuangoUserSearch from '@/app/components/user/Search'
  import TuangoUserProfile from '@/app/components/user/Profile'
  import TuangoTransactions from '@/app/components/user/Transactions'
  import TuangoCards from '@/app/components/user/Cards'
  import TuangoClaims from '@/app/components/user/Claims'

  export default {
    name: 'user-page',
    components: {
      TuangoUserSearch,
      TuangoUserProfile,
      TuangoTransactions,
      TuangoClaims,
      TuangoCards
    },
    data () {
      return {
        customers: [],
        selectedCustomer: null,
        currentView: null,
        loading: false
      }
    },
    methods: {
      onCustomer (customers) {
        this.customers = customers
        this.currentView = null
        if (!customers.length) {
          this.$notify.warning({
            title: 'Oups',
            message: 'Customer not found'
          })
        }
      },
      async showSection (section, customer) {
        this.loading = true
        this.selectedCustomer = customer

        let err, cards, claims

        [err, [cards, claims]] = await to(Promise.all([
          this.getUserCards(),
          this.getUserClaims()
        ]))

        this.loading = false

        if (err) {
          console.log(err)
          this.$notify.error({
            title: 'Error',
            message: 'Error occured'
          })

          return false
        }

        this.selectedCustomer.cards = cards
        this.selectedCustomer.claims = claims

        this.currentView = null
        this.currentView = section

        this.scrollToSection()
      },
      getUserCards () {
        return this.$api.cardsCustIdGet(
          {
            cust_id: this.selectedCustomer['cust_uid']
          })
          .then(res => {
            return CardTransformer.fetchCollection(res['data'])
          })
      },
      getUserClaims () {
        return this.$api.claimsCustIdGet(
          {
            cust_id: this.selectedCustomer['cust_uid']
          })
          .then(res => {
            return ClaimTransformer.fetchCollection(res['data'])
            // add email notification link
              .map(item => {
                item['claimEmailBtn'] = `<button type="button"
                                            class="btn blue btn-sm"
                                            data-action="resendClaimEmail"
                                            data-customer="${this.selectedCustomer['cust_uid']}"
                                            data-expires="${item.redeemExpiresTimeISO}"
                                            data-offer="${item.offerId}">
                                            <i class="fa fa-envelope-o"></i>
                                            Resend email
                                        </button>`
                return item
              })
          })
      },
      scrollToSection () {
        $('html, body').animate({
          scrollTop: $('#userdata').offset().top
        }, 2000)
      }
    },
    created () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/pages/User/Index.vue